import ErrorIcon from '@mui/icons-material/Error';
import { Tooltip } from '@mui/material';
import * as React from 'react';

import { STOP_WARNING_COLOR, stopHasWarning } from './utils';

// CP-8061: the map pin's "!" badge, next to a stop's name; the warning shows on hover (multiline since CP-7992).
const StopWarningIcon = ({ stop }) => {
    if (!stopHasWarning(stop)) return null;
    const text = stop.warning.trim();
    return (
        <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{text}</span>}>
            <ErrorIcon
                role="img"
                aria-hidden={false}
                aria-label={`Warning: ${text}`}
                sx={{ fontSize: 18, color: STOP_WARNING_COLOR, verticalAlign: 'text-bottom', ml: 0.5, flexShrink: 0 }}
            />
        </Tooltip>
    );
};

export default StopWarningIcon;
